
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { moneyFormat } from '@/utils/util'

@Component
export default class LineListCard extends Vue {
  @Prop({default: {}}) cards?: any //卡变展示数据
  @Prop({default: {}}) CardsType?: any //卡变展示字段信息
  @Prop({default: ''}) topLeft?: string // 卡片头部左边字符串
  @Prop({default: ''}) topRight?: string // 卡片头部右边字符串
  @Prop({default: 0}) lineStyle?: number // 卡片是否单行展示字段
  @Prop({default: 1}) orderType?: number // 卡片类型

  moneyFormat = moneyFormat
}
